import { combineReducers } from 'redux';
import { userReducer } from './userReducer';
import { authReducer } from './authReducer';
import { spendingReducer } from './spendingReducer';
import { categoriesReducer } from './categoriesReducer';
import { employeesReducer } from './employeesReducer';
import { servicesReducer } from './servicesReducer';
import { functionsReducer } from './functionsReducer';
import { salariesReducer } from './salariesReducer';
import { suppliersReducer } from './suppliersReducer';
import { labelsReducer } from './labelsReducer';
import { banksReducer } from './banksReducer';
import { paymentsReducer } from './paymentsReducer';
import { postsReducer } from './postsReducer';
import { incomesReducer } from './incomesReducer';
import { facturesReducer } from './facturesReducer';
import { transfersReducer } from './transfersReducer';
import { creditReducer } from './creditReducer';
import { debitReducer } from './debitReducer';
import { chargeReducer } from './chargeReducer';
import { paymentDetailsReducer } from './paymentDetailsReducer';
import { salaryCatsReducer } from './salaryCatsReducer';
import { accessReducer } from './accessReducer';
import { projectReducer } from './projectReducer';
import { projectStepReducer } from './projectStepReducer';
import { chantierReducer } from './chantierReducer';
import { timesheetReducer } from './timesheetReducer';
import { advanceReducer } from './advanceReducer';
import { advanceReturnReducer } from './advanceReturnReducer';
import { budgetReducer } from './budgetReducer';
import { equipementReducer } from './equipementReducer';
import { vehiculeReducer } from './vehiculeReducer';
import { loanReducer } from './loanReducer';
import { loanDemandReducer } from './loanDemandReducer';
import { usageReducer } from './usageReducer';
import { localisationReducer } from './localisationReducer';
import { immoTagsReducer } from './immoTagsReducer';
import { societyReducer } from './societyReducer';
import { demandReducer } from './demandReducer';
import { sessionReducer } from './sessionReducer';
import { articleReducer } from './articleReducer';
import requestReducer from './requestState/requestReducer';
import { spendingDemandReducer } from './spendingDemandReducer';


export const initialState = {
    // lang : 'fr',

};
export const appReducer = combineReducers({
    users: userReducer,
    spendings: spendingReducer,
    suppliers: suppliersReducer,
    labels: labelsReducer,
    banks: banksReducer,
    payments: paymentsReducer,
    payment_details: paymentDetailsReducer,
    salary_cats: salaryCatsReducer,
    credits: creditReducer,
    debits: debitReducer,
    charges: chargeReducer,
    categories: categoriesReducer,
    employees: employeesReducer,
    services: servicesReducer,
    functions: functionsReducer,
    salaries: salariesReducer,
    auth: authReducer,
    access: accessReducer,
    projects: projectReducer,
    steps: projectStepReducer,
    chantiers: chantierReducer,
    timesheets: timesheetReducer,
    advances: advanceReducer,
    advanceReturns: advanceReturnReducer,
    posts: postsReducer,
    incomes: incomesReducer,
    factures: facturesReducer,
    transfers: transfersReducer,
    budgets: budgetReducer,
    equipements: equipementReducer,
    vehicules: vehiculeReducer,
    loans: loanReducer,
    loanDemands: loanDemandReducer,
    usages: usageReducer,
    localisations: localisationReducer,
    immo_tags: immoTagsReducer,
    society: societyReducer,
    articles: articleReducer,
    sessions: sessionReducer,
    demands: demandReducer,
    request: requestReducer,
    spendingDemands: spendingDemandReducer

});
export const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        state = undefined
    }

    return appReducer(state, action)
}

